import axios from 'axios';

const API_URL = process.env.REACT_APP_BASEURL + 'batch';

export const getAllBatch = (params: any) => {
  return axios.get(`${API_URL}/all`, { params });
};

export const addBatch = async (reqData: any) => {
  return axios.post(`${API_URL}/add`, reqData);
};

export const updateBatch = async (batchId: string, data: any) => {
  return axios.put(`${API_URL}`, { batchId, ...data });
};
export const deleteBatch = async (batchId: string) => {
  return axios.delete(`${API_URL}`, {
    data: { batchId }
  });
};

export const getCoursesByOrgSlug = async (reqData: any) => {
  return axios.get(`${API_URL}/course-showcase`, { params: reqData });
};

export const searchSkillSectors = async (reqData: any) => {
  return axios.get(`${API_URL}/search-skill-sectors`, { params: reqData });
};

export const searchTrainingCentres = async (reqData: any) => {
  return axios.get(`${API_URL}/search-training-centres`, { params: reqData });
};

export const searchLocations = async (reqData: any) => {
  return axios.get(`${API_URL}/search-locations`, { params: reqData });
};

export const BatchwiseCourse = (params: any) => {
  return axios.get(`${API_URL}/details`, { params });
};

export const studentRequest = async (reqData: any) => {
  return axios.put(`${API_URL}/action`, reqData);
};
export const requestBatch = async (batchId: string) => {
  return axios.put(`${API_URL}/request`, { batchId});
};

export const studentDetails = async (reqData : any) => {
  return axios.put(`${API_URL}/updateDetails`, reqData);
};

export const createBatch = async (reqData : any) => {
  return axios.post(`${API_URL}/createBatch`, reqData);
};

export const getRequestedCourses = async (reqData : any) => {
  return axios.get(`${API_URL}/getRequestedCourses`, { params: reqData });
};

export const getUserDetails = async (reqData : any) => {
  return axios.get(`${API_URL}/getUserDetails`, { params: reqData });
};

export const batchEnrolled = async (reqData : any) => {
  return axios.get(`${API_URL}/isSubscribed`, { params: reqData });
};

export const updateBatchCourseProgress = async (reqData: any) => {
  return axios.put(`${API_URL}/course-progress`, reqData);
};

export const startBatch = async (reqData: any) => {
  return axios.put(`${API_URL}/start`, reqData);
};

export const addUsersToBatch = async (reqData: any) => {
  return axios.post(`${API_URL}/addUsers`, reqData);
};

export const sendMail = async (reqData: any) => {
  // Sends batch-completion email to awarding body (QP creator)
  return axios.post(`${API_URL}/completionMail`, reqData);
};

export const sendReassessmentRequestMail = async (reqData: {
  batchId: string;
  parentOrgId?: string;
  batchName?: string;
  organizationName?: string;
  failedCount?: number;
}) => {
  return axios.post(`${API_URL}/reassessmentRequestMail`, reqData);
};

export const sendAssessmentFailMail = async (reqData: {
  studentIds: string[];
  batchId: string;
  batchName?: string;
  courseName?: string;
  startDate?: string;
  endDate?: string;
}) => {
  return axios.post(`${API_URL}/assessmentFailMail`, reqData);
};

export const getAssessmentHistory = async (reqData: { studentId: string; batchId: string }) => {
  return axios.get(`${API_URL}/assessmentHistory`, { params: reqData });
};
